import { Link } from "react-router-dom";
import { LGoButton, LGoDialog } from "@/ui/branded";

interface CancelReservationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isCancelling: boolean;
  customerName: string;
  /** Null when the route out would lead where the partner already stands. */
  wholeOfferId: number | null;
}

export function CancelReservationDialog({
  open,
  onOpenChange,
  onConfirm,
  isCancelling,
  customerName,
  wholeOfferId,
}: CancelReservationDialogProps) {
  return (
    <LGoDialog
      open={open}
      onOpenChange={onOpenChange}
      size="sm"
      title="Zrušit rezervaci?"
      description="Zákazníkovi nic nestrhneme a jeho částku uvolníme zpět; místo bude zase volné. O zrušení mu dáme vědět v aplikaci i e-mailem. Tuto akci nelze vzít zpět."
      loading={isCancelling}
      footer={
        <>
          <LGoButton variant="secondary" onClick={() => onOpenChange(false)}>
            Zpět
          </LGoButton>
          <LGoButton variant="destructive" onClick={onConfirm} loading={isCancelling}>
            Zrušit rezervaci
          </LGoButton>
        </>
      }
    >
      <div className="space-y-3">
        <p className="text-sm font-medium text-foreground">{customerName}</p>
        {wholeOfferId !== null && (
          <p className="text-sm text-muted-foreground">
            Rušíte celou lekci? Můžete{" "}
            {/* The link leads to this same route, so without closing, the dialog
                would stay open over the button it sends the partner to. */}
            <Link
              to={`/reservations?offer=${wholeOfferId}`}
              className="underline underline-offset-4 hover:text-foreground"
              onClick={() => onOpenChange(false)}
            >
              zrušit celý slevový termín najednou
            </Link>{" "}
            i se všemi rezervacemi na ni.
          </p>
        )}
      </div>
    </LGoDialog>
  );
}
